function sendEventToParent(data: Record<string, any>) {
  // let parentOrigin = 'https://www.reaction-club.com'

  try {
    window.parent.postMessage(data, '*')
  } catch (e) {
    console.error('Failed to send event to parent:', '*')
  }
}

function sendAnalyticsEventToParent(data: any) {
  return sendEventToParent({
    type: 'analytics',
    data,
  })
}

function sendRedirectEvent(target: string, params?: Record<string, any>) {
  return sendEventToParent({
    type: 'redirect',
    data: {
      target,
      params,
    },
  })
}

export default {
  sendEventToParent,
  sendAnalyticsEventToParent,
  sendRedirectEvent,
}
